import React from 'react';

const certifications = [
  {
    title: 'Building RAG Agents with LLMs',
    issuer: 'NVIDIA',
    date: 'Issued Oct 9, 2026',
    credentialId: 'u8tIy0elTDCZPN4uksqzzQ',
    link: 'https://learn.nvidia.com/certificates?id=u8tIy0elTDCZPN4uksqzzQ',
    skills: ['Retrieval-Augmented Generation (RAG)', 'LLM Agents', 'LangChain', 'FAISS', 'Embedding Models', 'Semantic Search', 'FastAPI', 'LLM Evaluation', 'Dialog State Management', 'NVIDIA AI Technologies'],
  },
  {
    title: 'MLOps',
    issuer: 'Udemy',
    date: 'Completed 2025',
    skills: ['MLflow', 'Flask', 'GitHub Actions', 'CI/CD', 'Docker', 'Model deployment'],
  },
  {
    title: 'Pandas',
    issuer: 'Kaggle',
    date: 'Completed 2024',
    link: 'https://www.kaggle.com/learn/certification/muhammednihas/pandas',
    skills: ['Data manipulation', 'Grouping', 'Analysis'],
  },
];

const Certifications = () => (
  <div className="certification-list">
    {certifications.map((certification) => <article className="certification-entry" key={certification.title}>
      <div className="certification-heading"><span className="mono">{certification.issuer}</span>{certification.date && <span>{certification.date}</span>}</div>
      <h4>{certification.title}</h4>
      {certification.credentialId && <p className="credential-id">Credential ID: {certification.credentialId}</p>}
      <div className="tag-list">{certification.skills.map((skill) => <span className="tag" key={skill}>{skill}</span>)}</div>
      {certification.link && <a className="text-link" href={certification.link} target="_blank" rel="noopener noreferrer">Verify credential <span aria-hidden="true">↗</span></a>}
    </article>)}
  </div>
);

export default Certifications;
